import { env } from '@/config/env';
import { ProfilesResponse } from '@/features/user/types';

export const handleRolloutDataCheck = (data: ProfilesResponse.Root) => {
  if (env.IS_OFFLINE) {
    return;
  }
  const rolloutCookie = data?.rollout;
  const rolloutPlanEnabled = data?.rollout_enabled;
  if (rolloutPlanEnabled && (!rolloutCookie || rolloutCookie !== 'always')) {
    globalThis.location.reload();
  }
};
